<template>
  <div>
    <Loader v-if="loader" />

    <div class="page">
      <div class="content">
        <div v-if="activeStep === 1" class="button-wrapper">
          <button v-for="client in typeClients" :key="client.id" class="dynamic-button" @click="showForm(client.id, client.name)">
            {{ client.name }}
          </button>
        </div>

        <TabPanel v-if="selectedTypeClient">
          <template #header>
            <span v-if="activeStep === 1">
              Crea Cliente {{ selectedTypeName }}
            </span>
            <span v-else-if="activeStep === 2">
              Step 2: Associa Rappresentante
            </span>
          </template>
          <div v-if="activeStep === 1" class="formgrid grid mt-4">
            <div class="w-full flex flex-wrap">
              <div class="p-field col-12 xl:col-6">
                <label for="codfis">Codice Fiscale</label><br />
                <InputMask
                  :key="keyMask"
                  id="codfis"
                  :mask="maskCF"
                  v-model="cliente.codfis"
                  :class="[
                    'inputfield w-full',
                    { 'p-invalid': validationErrors.codfis && submitted },
                  ]"
                  @blur="onInputCodFis"
                  @input="cliente.codfis = cliente.codfis.toUpperCase()"
                />
                <small
                  v-show="validationErrors.codfis && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
                <small
                  v-show="validationErrors.codfis_invalid && submitted"
                  class="p-error"
                  >{{ selectedTypeClient === 3 ? 'Per i condomini il codice fiscale deve essere numerico di 11 caratteri.' : 'Campo non valido.' }}</small
                >
                <small
                  v-show="validationErrors.codfis_exist && submitted"
                  class="p-error"
                  >Cliente esistente.</small
                >
                <div
                  class="col-12 flex justify-content-between mt-3"
                  v-if="
                    selectedTypeClient != 2 &&
                    selectedTypeClient != 4 &&
                    selectedTypeClient != 3
                  "
                >
                  <label
                    ><strong
                      >La partita Iva coincide con il codice fiscale</strong
                    ></label
                  >
                  <Checkbox
                    v-model="sameCfPiva"
                    :binary="true"
                    @change="setSameCfPiva"
                    :disabled="selectedTypeClient == 4"
                  />
                </div>
              </div>
              <div
                class="p-field col-12 xl:col-6"
                v-if="selectedTypeClient != 2 && selectedTypeClient != 3"
              >
                <label for="piva">Partita Iva</label><br />
                <InputMask
                  mask="99999999999"
                  :disabled="sameCfPiva"
                  id="piva"
                  v-model="cliente.piva"
                  :class="[
                    'inputfield w-full',
                    { 'p-invalid': validationErrors.piva && submitted },
                  ]"
                />
                <small
                  v-show="validationErrors.piva && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
                <small
                  v-show="validationErrors.piva_invalid && submitted"
                  class="p-error"
                  >Campo non valido.</small
                >
                <small
                  v-show="validationErrors.piva_exist && submitted"
                  class="p-error"
                  >Cliente esistente.</small
                >
              </div>
              <div
                v-if="selectedTypeClient == 2"
                class="p-field col-12 xl:col-6"
              >
                <label for="nome">Nome</label><br />
                <InputText
                  id="nome"
                  v-model="cliente.nome"
                  :class="[
                    'inputfield w-full',
                    { 'p-invalid': validationErrors.nome && submitted },
                  ]"
                />
                <small
                  v-show="validationErrors.nome && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>
              <div
                v-if="selectedTypeClient == 2"
                class="p-field col-12 xl:col-6 mt-3"
              >
                <label for="cognome">Cognome</label><br />
                <InputText
                  id="cognome"
                  v-model="cliente.cognome"
                  :class="[
                    'inputfield w-full',
                    { 'p-invalid': validationErrors.cognome && submitted },
                  ]"
                />
                <small
                  v-show="validationErrors.cognome && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>
              <div v-if="selectedTypeClient != 2" class="p-field col-12 mt-3">
                <label for="ragsoc">Ragione Sociale</label><br />
                <InputText
                  id="ragsoc"
                  v-model="cliente.ragsoc"
                  :class="[
                    'inputfield w-full',
                    { 'p-invalid': validationErrors.ragsoc && submitted },
                  ]"
                />
                <small
                  v-show="validationErrors.ragsoc && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>
              <div class="p-field col-12 xl:col-6 mt-3">
                <label for="mobile">Cellulare</label><br />
                <InputMask
                  @change="onSelectedMobile($event)"
                  id="mobile"
                  mask="999-999999?9"
                  v-model="cliente.cellulare"
                  :class="[
                    'inputfield w-full',
                    { 'p-invalid': validationErrors.cellulare && submitted },
                  ]"
                />
                <small
                  v-show="validationErrors.cellulare && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
                <small
                  v-show="validationErrors.cellulare_incorrect"
                  class="p-error"
                  >Ricontrolla il numero di cellulare inserito.</small
                >
                <small v-show="validationErrors.noTelCell" class="p-error"
                  >Inserisci almeno un numero di cellulare o un telefono
                  fisso</small
                >
              </div>

              <Dialog
                id="modalShow"
                v-model:visible="showModal"
                :style="{ width: '450px' }"
                :modal="true"
              >
                <div class="confirmation-content">
                  <p>
                    Hai inserito il numero telefonico: {{ cliente.cellulare }}
                  </p>
                  <p>È corretto?</p>
                </div>
                <template #footer>
                  <Button
                    @click="isCorrect(true)"
                    label="Sì"
                    type="button"
                    icon="pi pi-check"
                    iconPos="left"
                    class="p-button-success btn-multisito m-2"
                  />
                  <Button
                    @click="isCorrect(false)"
                    label="No"
                    type="button"
                    icon="pi pi-times"
                    iconPos="left"
                    class="p-button-danger btn-multisito m-2"
                  />
                </template>
              </Dialog>

              <div class="p-field col-12 xl:col-6 mt-3">
                <label for="telefono">Telefono</label><br />
                <InputMask
                  @change="onSelectedTelefono($event)"
                  id="telefono"
                  mask="999-999999?9"
                  v-model="cliente.telefono"
                  :class="[
                    'inputfield w-full',
                    { 'p-invalid': validationErrors.telefono && submitted },
                  ]"
                />
              </div>

              <div class="p-field col-12 xl:col-6 mt-3">
                <label for="email">Email</label><br />
                <InputText
                  @change="onSelected($event)"
                  id="email"
                  v-model="cliente.email"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid':
                        validationErrors.email ||
                        (validationErrors.isEmail && submitted),
                    },
                  ]"
                  @input="
                    (val) => (cliente.email = cliente.email.toLowerCase())
                  "
                />
                <div
                  v-show="validationErrors.email && submitted"
                  class="p-error"
                >
                  Campo richiesto.
                </div>
                <div
                  v-show="validationErrors.isEmail && submitted"
                  class="p-error"
                >
                  Formato errato.
                </div>
              </div>

              <div
                v-if="selectedTypeClient != 2"
                class="p-field col-12 xl:col-6 mt-3"
              >
                <label for="pec">Pec</label><br />
                <InputText
                  id="pec"
                  v-model="cliente.pec"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid':
                        validationErrors.pec ||
                        (validationErrors.ispec && submitted),
                    },
                  ]"
                  @input="(val) => (cliente.pec = cliente.pec.toLowerCase())"
                />
              </div>

              <div class="p-field col-12 xl:col-6 mt-3">
                <label>Codice Sdi</label><br />
                <Dropdown
                  class="w-full"
                  v-model="cliente.sdi"
                  :options="sdi"
                  placeholder="Seleziona codice SDI"
                  :filter="true"
                  :showClear="true"
                  optionLabel="sdi"
                  optionValue="sdi"
                  :disabled="selectedTypeClient == 2"
                  :editable="selectedTypeClient == 5"
                />
                <small
                  v-show="validationErrors.sdi && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
                <small
                  v-show="validationErrors.sdi_invalid && submitted"
                  class="p-error"
                  >Formato errato.</small
                >
              </div>
            </div>
            <div class="p-field col-12 mt-2">
              <h5>Indirizzo sede legale</h5>
              <hr />
            </div>
            <div class="formgrid grid">
              <div class="p-field col-12 md:col-6">
                <label>Toponimo</label><br />
                <Dropdown
                  @change="onSelectedToponimo($event, 'legale')"
                  v-model="cliente.toponimo_legale"
                  :options="toponimi"
                  optionLabel="name"
                  optionValue="name"
                  :filter="true"
                  :editable="true"
                  placeholder="Seleziona toponimo"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid':
                        validationErrors.toponimo_legale && submitted,
                    },
                  ]"
                />
                <small
                  v-show="validationErrors.toponimo_legale && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>

              <div class="p-field col-12 md:col-6">
                <label for="indirizzo_legale">Indirizzo</label><br />
                <InputText
                  @change="onSelected($event)"
                  id="indirizzo_legale"
                  v-model="cliente.indirizzo_legale"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid':
                        validationErrors.indirizzo_legale && submitted,
                    },
                  ]"
                />
                <small
                  v-show="validationErrors.indirizzo_legale && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>

              <div class="p-field col-12 md:col-6">
                <label for="civico_legale">Civico</label><br />
                <InputText
                  @change="onSelected($event)"
                  id="civico_legale"
                  v-model="cliente.civico_legale"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid': validationErrors.civico_legale && submitted,
                    },
                  ]"
                />
                <small
                  v-show="validationErrors.civico_legale && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>

              <div class="p-field col-12 md:col-6">
                <label for="cap_legale">CAP</label><br />
                <InputMask
                  mask="99999"
                  @change="onSelected($event)"
                  id="cap_legale"
                  v-model="cliente.cap_legale"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid': validationErrors.cap_legale && submitted,
                    },
                  ]"
                />
                <small
                  v-show="validationErrors.cap_legale && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>

              <div class="p-field col-12 md:col-6">
                <label>Provincia</label><br />
                <Dropdown
                  @change="onSelectedDistrict($event, 'legale')"
                  v-model="cliente.provincia_legale"
                  :options="districts"
                  optionLabel="name"
                  optionValue="code"
                  :filter="true"
                  placeholder="Seleziona provincia"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid':
                        validationErrors.provincia_legale && submitted,
                    },
                  ]"
                />
                <small
                  v-show="validationErrors.provincia_legale && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>

              <div class="p-field col-12 md:col-6">
                <label>Comune</label><br />
                <Dropdown
                  @change="onSelectedCity($event, 'legale')"
                  v-model="cliente.comune_legale"
                  :options="cities_legale"
                  optionLabel="name"
                  optionValue="id"
                  :filter="true"
                  placeholder="Seleziona comune"
                  :class="[
                    'inputfield w-full',
                    {
                      'p-invalid': validationErrors.comune_legale && submitted,
                    },
                  ]"
                />
                <small
                  v-show="validationErrors.comune_legale && submitted"
                  class="p-error"
                  >Campo richiesto.</small
                >
              </div>
            </div>
            <div class="p-field col-12 flex justify-content-center mt-3 mb-1">
              <div v-if="errorMessage" class="error-message">
                {{ errorMessage }}
              </div>
            </div>

            <div class="p-field col-12 flex justify-content-center mt-1 mb-2">
              <button
                v-if="selectedTypeClient === 2"
                class="validate-client-button"
                @click="createClient"
              >
                Crea Cliente
              </button>
              <button
                v-else
                class="validate-client-button"
                @click="validateClient"
              >
                Avanti
              </button>
            </div>
          </div>
          <div v-else-if="activeStep === 2">
            <Step2
              :cliente="cliente"
              @goToStep2="handleStep2"
              @goBack="activeStep = 1"
              @stepCompleted="handleStepCompletion"
            />
          </div>
        </TabPanel>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, getCurrentInstance, onMounted } from "vue";
import CreaClientiService from "@/services/ask-operation/crea-clienti-service";
import Loader from "@/components/Loader.vue";
import TabPanel from "primevue/tabpanel";
import InputMask from "primevue/inputmask";
import InputText from "primevue/inputtext";
import Checkbox from "primevue/checkbox";
import Step2 from "@/pages/ask/dialogs/operations/clienti/DialogassociaRappCliente.vue";

export default {
  components: {
    Loader,
    TabPanel,
    InputMask,
    InputText,
    Checkbox,
    Step2,
  },
  setup() {
    const loader = ref(false);
    const typeClients = ref([]);
    const selectedTypeClient = ref(null);
    const selectedTypeName = ref("");
    const errorMessage = ref("");
    const activeStep = ref(1);
    const cliente = ref({
      codfis: "",
      piva: "",
      nome: "",
      cognome: "",
      ragsoc: "",
      cellulare: "",
      telefono: "",
      email: "",
      pec: "",
      sdi: "",
      toponimo_legale: "",
      indirizzo_legale: "",
      civico_legale: "",
      cap_legale: "",
      provincia_legale: "",
      comune_legale: "",
    });

    const contatto = ref({
      toponimo_spedizione: "",
      indirizzo_spedizione: "",
      civico_spedizione: "",
      cap_spedizione: "",
      provincia_spedizione: "",
      comune_spedizione: "",
    });

    const resetForm = () => {
      cliente.value = {
        codfis: "",
        piva: "",
        nome: "",
        cognome: "",
        ragsoc: "",
        cellulare: "",
        telefono: "",
        email: "",
        pec: "",
        sdi: "",
        toponimo_legale: "",
        indirizzo_legale: "",
        civico_legale: "",
        cap_legale: "",
        provincia_legale: "",
        comune_legale: "",
        toponimo_spedizione: "",
        indirizzo_spedizione: "",
        civico_spedizione: "",
        cap_spedizione: "",
        provincia_spedizione: "",
        comune_spedizione: "",
      };
    };
    const { emit } = getCurrentInstance();
    const validationErrors = ref({});
    const submitted = ref(false);
    const maskCF = ref("AAAAAAAAAAAAAAAA");
    const keyMask = ref(0);
    const sameCfPiva = ref(false);
    const sameAddress = ref(true);
    const newContatto = ref(false);
    const districts = ref([]);
    const sdi = ref([]);
    const toponimi = ref([]);
    const selectedContact = ref(null);
    const cities_legale = ref([]);
    const cities_spedizione = ref([]);
    const showModal = ref(false);

    const onSelectedCity = (evt, type_city) => {
      if (type_city === "legale") {
        cliente.value[`comune_${type_city}`] = evt.value;
      } else {
        contatto.value[`comune_${type_city}`] = evt.value;
      }
      delete validationErrors.value[`comune_${type_city}`];
    };

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const creaClientiService = new CreaClientiService(self.$http, self.$eventBus);

    onMounted(() => {
      fetchTypeClients();
      getSDI();
      getToponimi();
      getDistricts();
    });

    const fetchTypeClients = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getTypeClients();
        if (response.success) {
          typeClients.value = response.items;
        }
      } catch (error) {
        console.error("Errore nel caricamento dei tipi di clienti:", error);
      } finally {
        loader.value = false;
      }
    };

    const showForm = (id, name) => {
      selectedTypeClient.value = id;
      selectedTypeName.value = name;

      resetForm();

      cliente.value.tipo_client = id;

      switch (id) {
        case 1:
        case 5:
        case 6:
          maskCF.value = "99999999999";
          break;
        case 2:
          maskCF.value = "aaaaaa99a99a9**a";
          break;
        case 3:
          maskCF.value = "99999999999";
          break;
        case 4:
          sameCfPiva.value = false;
          maskCF.value = "aaaaaa99a99a9**a";
          break;
      }

      keyMask.value++;
    };

    const onInputCodFis = (e) => {
      cliente.value.codfis = e.target.value.toUpperCase();
      cliente.value.piva = sameCfPiva.value
        ? cliente.value.codfis
        : cliente.value.piva;
    };

    const setSameCfPiva = () => {
      if (sameCfPiva.value) {
        cliente.value.piva = cliente.value.codfis;
        delete validationErrors.value.piva;
        delete validationErrors.value.piva_exist;
        delete validationErrors.value.piva_invalid;
      } else {
        delete cliente.value.piva;
      }
    };

    const onInputToponimo = (evt, type) => {
      if (type == "legale") {
        cliente.value[`toponimo_${type}`] = evt.target.value.toUpperCase();
      } else {
        contatto.value[`toponimo_${type}`] = evt.target.value.toUpperCase();
      }
      delete validationErrors.value[`toponimo_${type}`];
    };

    const onSelectedToponimo = (evt, type) => {
      delete validationErrors.value[`toponimo_${type}`];
    };

    const setSameAddress = () => {
      let properties_address = [
        "toponimo",
        "indirizzo",
        "civico",
        "cap",
        "provincia",
        "comune",
      ];
      if (sameAddress.value) {
        properties_address.forEach((property) => {
          contatto.value[`${property}_spedizione`] =
            cliente.value[`${property}_legale`];
          delete validationErrors.value[`${property}_spedizione`];
        });
        contatto.value.cellulare = cliente.value.cellulare;
        contatto.value.email = cliente.value.email;
      } else {
        properties_address.forEach((property) => {
          delete contatto.value[`${property}_spedizione`];
        });
        delete contatto.value.cellulare;
        delete contatto.value.email;
      }
    };

    const setNewContatto = () => {
      delete validationErrors.value.contact;
      contatto.value = {};
      let properties_address = [
        "cellulare",
        "email",
        "toponimo_spedizione",
        "indirizzo_spedizione",
        "civico_spedizione",
        "cap_spedizione",
        "provincia_spedizione",
        "comune_spedizione",
      ];
      if (newContatto.value) {
        delete validationErrors.value.contact;
        selectedContact.value = null;
      } else {
        properties_address.forEach((property) => {
          delete cliente.value[`${property}`];
        });
      }
    };

    const onSelectedContact = () => {
      delete validationErrors.value.contact;
    };

    const onSelectedMobile = (evt) => {
      cliente.value.cellulare = evt.target.value;
      showModal.value = true;
      delete validationErrors.value["cellulare_incorrect"];
      delete validationErrors.value["cellulare"];
      delete validationErrors.value["noTelCell"];
    };
    const onSelectedTelefono = (evt) => {
      cliente.value.telefono = evt.target.value;
      delete validationErrors.value["cellulare_incorrect"];
      delete validationErrors.value["cellulare"];
      delete validationErrors.value["noTelCell"];
    };

    const isCorrect = (is_correct = false) => {
      if (!is_correct) {
        validationErrors.value["cellulare_incorrect"] = true;
      } else {
        delete validationErrors.value["cellulare_incorrect"];
      }
      showModal.value = false;
    };

    const setMaskForCF = (type) => {
      maskCF.value = type === "CF" ? "AAAAAAAAAAAAAAAA" : "99999999999";
    };

    const getSDI = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getSDI();
        if (response && response.items) {
          sdi.value = response.items.map((item) => ({
            sdi: item.sdi,
          }));
        } else {
          console.error("Errore: Nessun dato trovato nella risposta.");
        }
      } catch (error) {
        console.error("Errore durante il caricamento dei codici SDI:", error);
      } finally {
        loader.value = false;
      }
    };

    const getToponimi = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getToponimi();
        if (response && response.items) {
          toponimi.value = response.items.map((item) => ({
            name: item.name,
          }));
        } else {
          console.error("Errore: Nessun dato trovato nella risposta.");
        }
      } catch (error) {
        console.error("Errore durante il caricamento dei toponimi:", error);
      } finally {
        loader.value = false;
      }
    };

    const createClient = async () => {
      submitted.value = true;

      if (!validateForm()) {
        errorMessage.value = "Compila tutti i campi obbligatori.";
        setTimeout(() => {
          errorMessage.value = "";
        }, 9000);
        return;
      }

      // Creazione di un oggetto FormData per inviare i dati
      const fd = new FormData();
      fd.append(
        "data",
        JSON.stringify({
          cod_fiscale: cliente.value.codfis,
          partita_iva: cliente.value.piva,
          nome: cliente.value.nome,
          cognome: cliente.value.cognome,
          rag_sociale: cliente.value.ragsoc,
          mobile: cliente.value.cellulare,
          phone: cliente.value.telefono,
          email: cliente.value.email,
          pec: cliente.value.pec,
          codice_destinatario: cliente.value.sdi,
          toponimo: cliente.value.toponimo_legale,
          address: cliente.value.indirizzo_legale,
          civico: cliente.value.civico_legale,
          cap: cliente.value.cap_legale,
          cityId: cliente.value.comune_legale,
          tipo_client: selectedTypeClient.value,
        })
      );

      loader.value = true;
      errorMessage.value = "";

      try {
        // Chiamata alla funzione saveClient
        const response = await creaClientiService.saveClient(fd);

        if (response.success) {
          resetForm();
          submitted.value = false;
          errorMessage.value = "Cliente creato con successo.";
          setTimeout(() => {
            errorMessage.value = "";
          }, 9000);
        } else {
          errorMessage.value =
            response.message || "Errore durante la creazione del cliente.";
          setTimeout(() => {
            errorMessage.value = "";
          }, 9000);
        }
      } catch (error) {
        console.error("Errore durante la richiesta al backend:", error);
        errorMessage.value = "Errore nella comunicazione con il server.";
        setTimeout(() => {
          errorMessage.value = "";
        }, 9000);
      } finally {
        loader.value = false;
      }
    };

    const getDistricts = async () => {
      loader.value = true;
      try {
        const response = await creaClientiService.getDistricts();
        if (response && response.items) {
          districts.value = response.items.map((item) => ({
            name: item.name,
            code: item.code,
          }));
        } else {
          console.error("Errore: Nessun dato trovato nella risposta.");
        }
      } catch (error) {
        console.error("Errore durante il caricamento dei districts:", error);
      } finally {
        loader.value = false;
      }
    };

    const onSelectedDistrict = async (evt, type_district) => {
      try {
        if (type_district === "legale") {
          cliente.value.provincia_legale = evt.value;
          cities_legale.value = [];
          cliente.value.comune_legale = "";
        } else {
          contatto.value.provincia_spedizione = evt.value;
          cities_spedizione.value = [];
          contatto.value.comune_spedizione = "";
        }

        delete validationErrors.value[`provincia_${type_district}`];

        const response = await creaClientiService.getCities(evt.value);
        if (response && response.items) {
          const formattedCities = response.items.map((item) => ({
            id: item.id,
            name: item.name,
          }));

          if (type_district === "legale") {
            cities_legale.value = formattedCities;
          } else {
            cities_spedizione.value = formattedCities;
          }
        } else {
          console.error(
            `Errore: Nessun dato trovato per la provincia con code ${evt.value}`
          );
        }
      } catch (error) {
        console.error(
          `Errore durante il caricamento delle città per la provincia con code ${evt.value}:`,
          error
        );
      }
    };

    const onSelectedSdi = () => {
      delete validationErrors.value.sdi;
      delete validationErrors.value.sdi_invalid;
    };

    const onSelected = (evt) => {
      delete validationErrors.value[evt.target.id];
      if (evt.target.id == "email") {
        delete validationErrors.value["isEmail"];
      } else if (evt.target.id == "codfis") {
        delete validationErrors.value["codfis_invalid"];
        delete validationErrors.value["codfis_exist"];
        if (sameCfPiva.value) {
          delete validationErrors.value["piva_invalid"];
          delete validationErrors.value["piva_exist"];
        }
      } else if (evt.target.id == "piva") {
        delete validationErrors.value["piva_invalid"];
        delete validationErrors.value["piva_exist"];
      }
    };

    const validateClient = async () => {
      submitted.value = true;

      if (!validateForm()) {
        errorMessage.value = "Compila tutti i campi obbligatori.";
        setTimeout(() => {
          errorMessage.value = "";
        }, 9000);
        return;
      }

      const payload = {
        typeClient: selectedTypeClient.value,
        ...cliente.value,
        contact: sameAddress.value ? cliente.value : contatto.value,
      };

      loader.value = true;
      errorMessage.value = "";

      try {
        const response = await creaClientiService.validateClient(payload);

        if (response.success) {
          emit("goToStep2", cliente.value);
          activeStep.value = 2;
          submitted.value = false;
        } else {
          errorMessage.value =
            response.message || "Errore durante la creazione del cliente.";
          setTimeout(() => {
            errorMessage.value = "";
          }, 9000);
        }
      } catch (error) {
        console.error("Errore durante la richiesta al backend:", error);
        errorMessage.value = "Errore nella comunicazione con il server.";
        setTimeout(() => {
          errorMessage.value = "";
        }, 9000);
      } finally {
        loader.value = false;
      }
    };

    const validateForm = () => {
      validationErrors.value = {};

      if (!cliente.value.codfis) {
        validationErrors.value.codfis = true;
      } else if (selectedTypeClient.value === 3) {
        const cfRegex = /^\d{11}$/;
        if (!cfRegex.test(cliente.value.codfis)) {
          validationErrors.value.codfis_invalid = true;
        }
      }

      if (!cliente.value.nome && selectedTypeClient.value === 2) {
        validationErrors.value.nome = true;
      }

      if (!cliente.value.ragsoc && selectedTypeClient.value !== 2) {
        validationErrors.value.ragsoc = true;
      }

      if (!cliente.value.cellulare && !cliente.value.telefono) {
        validationErrors.value.noTelCell = true;
      }

      if (!cliente.value.email) {
        validationErrors.value.email = true;
      }

      if (!cliente.value.cap_legale) {
        validationErrors.value.cap_legale = true;
      }

      if (!cliente.value.provincia_legale) {
        validationErrors.value.provincia_legale = true;
      }

      if (!cliente.value.comune_legale) {
        validationErrors.value.comune_legale = true;
      }

      return Object.keys(validationErrors.value).length === 0;
    };

    return {
      loader,
      typeClients,
      selectedTypeClient,
      selectedTypeName,
      cliente,
      contatto,
      validationErrors,
      submitted,
      maskCF,
      showForm,
      keyMask,
      onInputCodFis,
      sameCfPiva,
      setSameCfPiva,
      onSelectedToponimo,
      onInputToponimo,
      setNewContatto,
      setSameAddress,
      sameAddress,
      newContatto,
      selectedContact,
      onSelectedContact,
      setMaskForCF,
      getSDI,
      sdi,
      onSelectedSdi,
      getToponimi,
      toponimi,
      getDistricts,
      districts,
      onSelectedDistrict,
      onSelectedCity,
      cities_legale,
      showModal,
      validateClient,
      onSelected,
      errorMessage,
      onSelectedMobile,
      onSelectedTelefono,
      isCorrect,
      Step2,
      activeStep,
      createClient,
    };
  },
};
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.dynamic-button {
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: bold;
  margin: 5px;
  border-radius: 5px;
  cursor: pointer;
}

.dynamic-button:hover {
  background-color: #357ab8;
}

.inputfield {
  width: 100%;
}

.p-error {
  color: red;
  font-size: 12px;
}

.formgrid {
  margin-top: 1px;
  margin-left: 1px;
}

.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.md\:col-6 {
  width: 30%;
}

button {
  padding: 1.3em 3em;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 2.5px;
  font-weight: 500;
  color: #000;
  background-color: #fff;
  border: none;
  border-radius: 45px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
  margin-right: 10px;
  margin-top: 10px;
}

button:hover {
  background-color: #357bb8c4;
  box-shadow: 0px 15px 20px #357ab8;
  color: #fff;
  transform: translateY(-5px);
}

button:active {
  transform: translateY(-5px);
}

.validate-client-button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.validate-client-button:hover {
  background-color: #45a049;
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.3);
}

.validate-client-button:active {
  transform: translateY(1px);
}

.error-message {
  color: red;
  font-size: 14px;
  margin-bottom: 15px;
  text-align: center;
  background-color: #ffe6e6;
  padding: 10px;
  border: 1px solid red;
  border-radius: 5px;
  max-width: 80%;
  align-self: center; /* Centra il messaggio */
}
</style>

